export default {"src":"/_next/static/media/in_game_account_add_user_green.aad24dc7.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};